/**
 * @file
 * Tip Grid script.
 */

(function tipGridScript($, Drupal, _) {
  'use strict';

  Drupal.behaviors.tipGrid = {
    attach: function tipGridAttach(context) {
      const $grid = $('.tip-grid__layout', context);

      if (!$grid.length) {
        return;
      }

      $grid.masonry({
        itemSelector: '.squircle',
        percentPosition: true,
        columnWidth: '.squircle',
        gutter: '.gutter-sizer',
        horizontalOrder: true
      });

      // Resize.
      $(window).on('resize', _.debounce(function windowResize() {
        $grid.masonry('layout');
      }, 100)).resize();
    }
  };
}(jQuery, Drupal, _));
